import type { AmbleContent } from "../..";
import { wholesalerContactInfoAgentEmailCopy } from "../../shared/wholesaler-contact-info";

export const ambles: Record<string, AmbleContent> = {
  usa_wholesaler_contact_information: wholesalerContactInfoAgentEmailCopy,
};
